<template>
  <!--
    DrawingAnnotationPanel
    -------------------------------------------------------------------------
    Gerencia as anotações de texto: criar, editar, selecionar e remover.
    A movimentação acontece direto no canvas (arraste). Aqui é a lista + criação.
  -->
  <div class="std-annotations">
    <div class="std-ann-heading">
      <div>
        <v-icon size="15" color="#555">mdi-format-text</v-icon>
        Anotações ({{ annotations.length }})
      </div>
      <v-btn x-small depressed class="std-ann-add" @click="$emit('add')">
        <v-icon size="15" left>mdi-plus</v-icon> Nova
      </v-btn>
    </div>

    <div v-if="!annotations.length" class="std-list-empty">
      Nenhuma anotação. Use a ferramenta de texto ou "Nova".
    </div>

    <div
      v-for="ann in annotations"
      :key="ann.id"
      class="std-ann-row"
      :class="{ active: isSelected(ann.id) }"
      @click="$emit('select', { kind: 'annotation', id: ann.id })"
    >
      <v-text-field
        dense hide-details solo flat
        class="std-ann-input"
        :value="ann.text"
        @input="$emit('update', { id: ann.id, patch: { text: $event } })"
        @focus="$emit('select', { kind: 'annotation', id: ann.id })"
      ></v-text-field>
      <v-btn icon x-small @click.stop="$emit('remove', { kind: 'annotation', id: ann.id })">
        <v-icon size="16" color="grey">mdi-delete</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "DrawingAnnotationPanel",
  props: {
    annotations: { type: Array, default: () => [] },
    selection: { type: Object, default: () => ({ kind: null, id: null }) }
  },
  methods: {
    isSelected(id) {
      return (
        this.selection &&
        this.selection.kind === "annotation" &&
        this.selection.id === id
      );
    }
  }
};
</script>

<style scoped>
.std-annotations {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.std-ann-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11px;
  font-weight: 700;
  color: #173b33;
}
.std-ann-add {
  border-radius: 8px !important;
}
.std-ann-row {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 4px 2px 8px;
  border-radius: 8px;
  background: #fffbe6;
  border: 1px solid rgba(178, 94, 0, 0.18);
  cursor: pointer;
}
.std-ann-row.active {
  border-color: #173b33;
  box-shadow: 0 0 0 1px rgba(251, 174, 29, 0.3);
}
.std-ann-input {
  font-size: 12px;
}
.std-list-empty {
  font-size: 11px;
  color: #9fb3ab;
  padding: 2px 4px;
}
</style>
